import axios from "axios";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import BaseURL from "../../BaseURL/BaseURL";
import { Oval } from "react-loader-spinner";

const Register = () => {
  const [FirstName, setFirstName] = useState("");
  // const [LastName, setLastName] = useState("");
  const [Email, setEmail] = useState("");
  const [Password, setPassword] = useState("");
  // const [Image, setImage] = useState();
  // const [File, setFile] = useState();
  const [Loader, setLoader] = useState(false);
  const [, setApi] = useState([]);


  console.log(Image,File,"Image")
  const Navigate = useNavigate();

  // const handleImageUpload = (event) => {
  //   setFile(event.target.files[0])
  //   const file = event.target.files[0];
  //   const reader = new FileReader();
  
  //   reader.onloadend = () => {
  //     setImage({
  //       Image: reader.result,
  //     });
  //   };
  
  //   if (file) {
  //     reader.readAsDataURL(file);
  //   }
  // };


  const register = () => {
    setLoader(true);
    try {
      const data = new FormData();
      data.append("name", FirstName);
      data.append("email", Email);
      data.append("password", Password);
      // data.append("image", File);

      var config = {
        method: "POST",
        url: `${BaseURL.baseurl}/user`,
        data: data,
      };

      axios(config)
        .then(function (response) {
          console.log(response, "api");
          setApi(response.data.property);
          if (response.data.status === true) {
            setLoader(false);
            Swal.fire({
              title: "Good job! ",
              text: "Register Successfully",
              icon: "success",
              button: "Ok",
            });
            Navigate("/login");
          } else {
            setLoader(false);
          }
        })
        .catch((errors) => {
          setLoader(false);
          Swal.fire({
            title: "Something Went Wrong",
            text: errors.errors ? errors.errors[0] : "check your Details",
            icon: "error",
            dangerMode: true,
          });
        });
    } catch (errors) {
      setLoader(false);
      console.log(errors, "error");
      Swal.fire({
        title: "Something Went Wrong",
        text: errors.errors ? errors.errors[0] : "check your Details",
        icon: "error",
        dangerMode: true,
      });
    }
  };

  return (
    <>
      <main>
        <div id="hero_register">
          <div class="container margin_120_95">
            <div class="row">
              {/* <!-- /col --> */}
              <div className="col-lg-7">
              <span className="rejisterdiv d-flex">
              <img src="./fav.png" className="rejisterimg" alt="ok" />
              <span className="rejisterspan">Dentective</span>
              </span>
              </div>
              <div class="col-lg-5 mt-5 rejisterseconddiv">
                <div class="box_form mt-5">
                  <div id="message-register"></div>
                  <form>
                    <h2 className="text-center pb-4 text-theme rejissterh2">Register</h2>
                    <span className="rejisterspan20">Register Dentective</span>
                    <hr className="text-white"/>
                    {/* <div className="row">
                      <div className="col-md-12 d-flex justify-content-center align-items-center flex-column">
                        <div class="circle mb-3">
                          <img
                            class="profile_pic"
                            src={Image ? Image.Image :`https://t3.ftcdn.net/jpg/03/46/83/96/360_F_346839683_6nAPzbhpSkIpb8pmAwufkC7c5eD7wYws.jpg`} alt=""
                          />
                        </div>
                        <div class="p-image">
                          <input
                            class="file-upload"
                            type="file"
                            accept="image/*"
                            onChange={handleImageUpload}
                          />
                          <button type="button" className="upload-button">Upload</button>
                        </div>
                      </div>
                    </div> */}
                    <div class="row mt-3">
                      <div class="col-md-12 ">
                        <div class="form-group">
                          <input
                            type="text"
                            class="form-control shadow"
                            placeholder="First Name"
                            name="name_register"
                            id="name_register"
                            onChange={(e) => setFirstName(e.target.value)}
                          />
                        </div>
                      </div>
                      {/* <div class="col-md-6">
                        <div class="form-group">
                          <input
                            type="text"
                            class="form-control shadow"
                            placeholder="Last Name"
                            name="lastname_register"
                            id="lastname_register"
                            // onChange={(e) => setLastName(e.target.value)}
                          />
                        </div>
                      </div> */}
                    </div>
                    <div class="row">
                      <div class="col-lg-12">
                        <div class="form-group">
                          <input
                            type="email"
                            class="form-control shadow"
                            placeholder="Email Address"
                            name="email_register"
                            id="email_register"
                            onChange={(e) => setEmail(e.target.value)}
                          />
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-lg-12">
                        <div class="form-group">
                          <input
                            type="password"
                            class="form-control shadow"
                            placeholder="password"
                            name="password"
                            id="password"
                            onChange={(e) => setPassword(e.target.value)}
                          />
                        </div>
                      </div>
                    </div>
                    <p class="text-center link_bright text-white">
                Do have Allready account Login{" "}
                <Link to="/Login">
                  <strong className="text-theme">Login now!</strong>
                </Link>
              </p>
                  </form>
                  <div className="w-100 d-flex -justify-content-center">
                    <button
                      class="btn-theme w-50 mx-auto d-flex justify-content-center align-items-center"
                      onClick={register}
                    >
                      {Loader === true ? (
                        <Oval
                          height={30}
                          width={30}
                          color="#fff"
                          wrapperStyle={{}}
                          wrapperClass=""
                          visible={true}
                          ariaLabel="oval-loading"
                          secondaryColor="#4fa94d"
                          strokeWidth={2}
                          strokeWidthSecondary={2}
                        />
                      ) : (
                        "Register"
                      )}
                    </button>
                  </div>
                </div>
                {/* <!-- /box_form --> */}
              </div>
              {/* <!-- /col --> */}
            {/* <!-- /row --> */}
        <br/>
        <br/>
        <br/>
            </div>
          </div>
          {/* <!-- /container --> */}
        </div>
        {/* <!-- /hero_register --> */}
      </main>
    </>
  );
};

export default Register;
